// pages/Menu/MenuRedirect.jsx
//
// Handles the bare /menu route - every internal link (Header nav,
// HomeHero's CTAs, Cart's "Browse Menu", OrderForm's empty-cart link)
// still points here rather than a specific restaurant. With exactly one
// active restaurant, that's an unambiguous redirect straight to its menu
// (query string/hash preserved, e.g. /menu?category=lunch still lands on
// the right tab). With more than one, there's no restaurant to guess -
// rather than bouncing to the homepage (which reads as a broken "Menu"
// link that dumps you back at the marketing hero), this renders the same
// restaurant picker in place, so /menu always lands on an actual
// menu-related page.
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import RestaurantDirectory from "../../components/RestaurantDirectory/RestaurantDirectory";

const MenuRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState("loading"); // "loading" | "picker" | "failed"

  useEffect(() => {
    const resolve = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/restaurant`);
        const restaurants = response.data.restaurants || [];
        if (restaurants.length === 1) {
          navigate(`/menu/${restaurants[0].slug}${location.search}${location.hash}`, { replace: true });
        } else {
          setStatus("picker");
        }
      } catch (error) {
        console.error("Error resolving /menu redirect:", error);
        setStatus("failed");
      }
    };
    resolve();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (status === "failed") {
    return (
      <main className="menu-page">
        <div className="section-container text-center py-16">
          <h2 className="section-heading text-dark mb-4">Couldn't load restaurants</h2>
          <a href="/" className="btn btn-primary">
            Back home
          </a>
        </div>
      </main>
    );
  }

  if (status === "picker") {
    return (
      <main className="menu-page">
        <RestaurantDirectory />
      </main>
    );
  }

  return null;
};

export default MenuRedirect;
